import React, { useState } from "react";
import { login } from "../api";

export default function ConfirmPasswordDialog({ username, message, onConfirm, onCancel }) {
  const [user, setUser] = useState(username || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    if (!user || !password || loading) return;

    setLoading(true);
    setError("");
    try {
      const res = await login(user, password);
      if (res.status === "success") {
        onConfirm();
      } else {
        setError("Sai mật khẩu, vui lòng thử lại");
      }
    } catch {
      setError("Không kết nối được tới máy chủ");
    }
    setLoading(false);
  };

  return (
    <div className="modal">
      <div className="modal-box">
        <h3 style={{ color: "#d90000" }}>Xác nhận xóa thư mục</h3>
        <p>{message}</p>

        <form onSubmit={submit}>
          {!username && (
            <input
              type="text"
              placeholder="Mã số nhân viên..."
              value={user}
              onChange={(e) => setUser(e.target.value)}
              autoFocus
            />
          )}
          <input
            type="password"
            placeholder="Nhập lại mật khẩu để xác nhận..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus={!!username}
          />

          {error && <div className="login-error">{error}</div>}

          <div className="modal-actions">
            <button className="btn danger" type="submit" disabled={loading || !user || !password}>
              {loading ? "Đang kiểm tra..." : "Xác nhận xóa"}
            </button>
            <button className="btn cancel" type="button" onClick={onCancel} disabled={loading}>
              Hủy
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
